import React from "react";
import { createRoot } from "react-dom/client";

import AppRouter from "./AppRouter";
import ErrorBoundary from "./components/ErrorBoundary";
import { QueryClientProvider } from "@tanstack/react-query";
import { queryClient } from "./api/queries/queryClient";
import { AuthProvider } from "./context/AuthContext";
import i18n from "config/i18n";
// @ts-expect-error side-effect import of global stylesheet
import "../assets/styles/main.scss";

void i18n;

const rootElement = document.getElementById("app");

if (rootElement) {
  createRoot(rootElement).render(
    <React.StrictMode>
      <QueryClientProvider client={queryClient}>
        <AuthProvider>
          <ErrorBoundary>
            <AppRouter />
          </ErrorBoundary>
        </AuthProvider>
      </QueryClientProvider>
    </React.StrictMode>
  );
}
